import React from 'react'

export const mergeRefs = <
  T extends React.RefObject<any> | React.ForwardedRef<any>,
>(
  ...refs: T[]
) => {
  return (node: Node) => {
    for (const ref of refs) {
      ref.current = node
    }
  }
}
